import(/* webpackMode: "eager" */ "/vercel/path0/src/app/garage/page.tsx");
